const { apiHandler } = require("assets/api");
const { endpoint } = require("assets/api/endpoint");
const { repledgeCaseListName } = require("assets/properties/properties");
const { parseDate, parseAndSetFlag } = require("utils/Utils");

export const getDisbursalDatePreviousLoan = async (
  subStatus,
  featureFlags,
  prePledgeLoan,
  authToken,
  loanApplicationId,
  setCallInProgress,
  preLoanSubType,
  prepledgeLoanMap
) => {
  if (
    subStatus === repledgeCaseListName?.topUp &&
    Object.keys(prepledgeLoanMap || {} )?.length === 1 && 
    parseAndSetFlag(featureFlags?.sameDayLoanProcessingFees) &&
    (preLoanSubType === repledgeCaseListName?.renew ||
      preLoanSubType === repledgeCaseListName?.partRelease)
  ) {
    const closureResponse = await apiHandler({
      url: endpoint.GET_LOAN_DETAILS + prePledgeLoan?.trim(),
      authToken,
    });

    if (closureResponse?.data?.disbursalDate === parseDate(new Date())) {
      const amount = await GetLoanOrnamentDetails(
        loanApplicationId,
        authToken,
        prePledgeLoan?.trim()
      );
      return amount;
    }
  }

  setCallInProgress(false);
  return 0;
};

const GetLoanOrnamentDetails = async (
  loanApplicationId,
  authToken,
  prePledgeLoan
) => {
  const result = await apiHandler({
    url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
    authToken,
  });

  return await GetLoanClosureDuesDetails(
    result?.data?.actualLoanAmount,
    authToken,
    prePledgeLoan
  );
};

const GetLoanClosureDuesDetails = async (
  actualAmount,
  authToken,
  prePledgeLoan
) => {
  const result = await apiHandler({
    url: endpoint.FIND_MAX_ROI_INTEREST_DATE + prePledgeLoan,
    authToken,
  });

  return await GetLoanClosureDuesDetail(
    result?.data?.interestTillDate,
    prePledgeLoan?.trim(),
    result?.data?.maxRoi,
    actualAmount,
    authToken
  );
};

const GetLoanClosureDuesDetail = async (
  currentDate,
  loanAccountNumber,
  maxROIInterest,
  actualAmount,
  authToken
) => {
  const result = await apiHandler({
    url:
      endpoint.LOAN_CLOSURE_DUES +
      `?penaltyRate=0&waveOff=0&refund=0&interestTillDate=${currentDate}&loanAccountNumber=${loanAccountNumber}&maxRoi=${maxROIInterest}`,
    authToken,
  });

  return Number(actualAmount) - Number(result?.data?.totalDues);
};